module.exports = __webpack_public_path__ + "img/play.4f8e77ad.svg";